import { Container, Heading, Text, VStack, Box, UnorderedList, ListItem, useColorModeValue } from '@chakra-ui/react'

export default function TermsOfService() {
  return (
    <Box minH="100vh" w="100vw" bg={useColorModeValue('gray.50', 'gray.900')}>
      <Container 
        maxW={{ base: 'container.sm', md: 'container.md', lg: 'container.lg' }}
        py={{ base: 8, md: 12 }}
        px={{ base: 4, md: 8 }}
      >
        <VStack spacing={{ base: 6, md: 8 }} align="stretch" w="full">
          <VStack spacing={2} textAlign="center" w="full">
            <Heading 
              as="h1" 
              size={{ base: 'lg', md: 'xl' }}
            >
              Terms of Service
            </Heading>
          </VStack>

          <Text fontSize={{ base: 'sm', md: 'md' }} textAlign="center">
            Welcome to VehicleLogi, a comprehensive vehicle expense tracking and management platform. These Terms of Service govern your use of our service.
          </Text>

          <VStack spacing={8} align="stretch">
            <Box>
              <Heading as="h2" size={{ base: 'md', md: 'lg' }} mb={3}>
                Service Description
              </Heading>
              <Text fontSize={{ base: 'sm', md: 'md' }} mb={3}>
                VehicleLogi provides a web-based platform for tracking and managing vehicle-related expenses, including:
              </Text>
              <UnorderedList 
                spacing={2} 
                pl={4}
                fontSize={{ base: 'sm', md: 'md' }}
              >
                <ListItem>Expense logging and categorization</ListItem>
                <ListItem>Vehicle maintenance tracking</ListItem>
                <ListItem>Financial reporting and analytics</ListItem>
                <ListItem>Secure cloud-based storage</ListItem>
              </UnorderedList>
            </Box>

            <Box>
              <Heading as="h2" size={{ base: 'md', md: 'lg' }} mb={3}>
                User Account Responsibilities
              </Heading>
              <Text fontSize={{ base: 'sm', md: 'md' }} mb={3}>
                When using VehicleLogi, you agree to:
              </Text>
              <UnorderedList 
                spacing={2} 
                pl={4}
                fontSize={{ base: 'sm', md: 'md' }}
              >
                <ListItem>Provide accurate and complete account information</ListItem>
                <ListItem>Maintain the confidentiality of your account credentials</ListItem>
                <ListItem>Be responsible for all activities under your account</ListItem>
                <ListItem>Use the service only for lawful purposes</ListItem>
                <ListItem>Not share your account with unauthorized individuals</ListItem>
              </UnorderedList>
            </Box>

            <Box>
              <Heading as="h2" size={{ base: 'md', md: 'lg' }} mb={3}>
                Subscription and Payments
              </Heading>
              <Text fontSize={{ base: 'sm', md: 'md' }} mb={3}>
                Details of our subscription model:
              </Text>
              <UnorderedList 
                spacing={2} 
                pl={4}
                fontSize={{ base: 'sm', md: 'md' }}
              >
                <ListItem>Subscription fees are charged monthly or annually</ListItem>
                <ListItem>Prices are subject to change with 30 days notice</ListItem>
                <ListItem>Cancellation can be done at any time through account settings</ListItem>
                <ListItem>Taxes and additional fees may apply depending on your location</ListItem>
                <ListItem>No refunds will be provided for partial billing periods</ListItem>
              </UnorderedList>
            </Box>

            <Box>
              <Heading as="h2" size={{ base: 'md', md: 'lg' }} mb={3}>
                Data and Content Ownership
              </Heading>
              <Text fontSize={{ base: 'sm', md: 'md' }} mb={3}>
                Regarding your data and content:
              </Text>
              <UnorderedList 
                spacing={2} 
                pl={4}
                fontSize={{ base: 'sm', md: 'md' }}
              >
                <ListItem>You retain legal ownership of the data you input into VehicleLogi</ListItem>
                <ListItem>You grant VehicleLogi and its developers a perpetual, worldwide, royalty-free license to use, modify, reproduce, distribute, and create derivative works from your uploaded content</ListItem>
                <ListItem>VehicleLogi may use your data for any purpose, including but not limited to service improvement, analytics, machine learning, and commercial purposes</ListItem>
                <ListItem>You waive any claims of compensation for the use of your data</ListItem>
                <ListItem>You can export or delete your data at any time, but prior uses of the data remain valid</ListItem>
              </UnorderedList>
            </Box>

            <Box>
              <Heading as="h2" size={{ base: 'md', md: 'lg' }} mb={3}>
                Limitation of Liability
              </Heading>
              <Text fontSize={{ base: 'sm', md: 'md' }} mb={3}>
                Important liability considerations:
              </Text>
              <UnorderedList 
                spacing={2} 
                pl={4}
                fontSize={{ base: 'sm', md: 'md' }}
              >
                <ListItem>Service is provided "as is" without warranties</ListItem>
                <ListItem>We are not liable for any financial decisions based on our analytics</ListItem>
                <ListItem>Maximum liability is limited to the amount paid in the last 6 months</ListItem>
                <ListItem>We are not responsible for data loss due to user error</ListItem>
              </UnorderedList>
            </Box>

            <Box>
              <Heading as="h2" size={{ base: 'md', md: 'lg' }} mb={3}>
                Changes to Terms
              </Heading>
              <Text fontSize={{ base: 'sm', md: 'md' }}>
                We may update these Terms of Service from time to time. We will notify you of any significant changes by posting the new terms on this page and updating the "Last updated" date.
              </Text>
            </Box>

            <Box>
              <Heading as="h2" size={{ base: 'md', md: 'lg' }} mb={3}>
                Contact Us
              </Heading>
              <Text fontSize={{ base: 'sm', md: 'md' }}>
                If you have any questions about these Terms of Service, please contact us at legal@vehiclelogi.com.
              </Text>
            </Box>
          </VStack>

          <Text fontSize={{ base: 'xs', md: 'sm' }} textAlign="center" color="gray.500">
            By using VehicleLogi, you acknowledge that you have read, understood, and agree to be bound by these Terms of Service.
          </Text>
          <Text fontSize="sm" color="gray.500" textAlign="center" mt={4}>
            Last Updated: January 18, 2025
          </Text>
        </VStack>
      </Container>
    </Box>
  );
}
